/* MyZimmerpflanze Theme: Navigation, Warenkorb, Suche, Produkt- und Kategorielogik, Animationen */
(() => {
  const R = window.MZ.routes;
  const FREE = window.MZ.freeShipping; // in Cent
  const SHIP = window.MZ.shipping;
  gsap.registerPlugin(ScrollTrigger, Flip, SplitText);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = window.matchMedia('(hover: hover)').matches;
  const dur = s => (reducedMotion ? 0 : s);

  /* ---------- Helfer ---------- */
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  // Gleiches Format wie Shopifys money-Filter (Shop-Einstellung), damit Preise nach dem Umschalten nicht anders aussehen
  const moneyFormat = window.MZ?.moneyFormat || '{{amount_with_comma_separator}} €';
  const money = cents => {
    const n = (Number(cents) || 0) / 100;
    const de = (d, t = '.') => n.toFixed(d).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, t);
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k === 'amount_with_comma_separator' ? de(2) : k === 'amount_no_decimals_with_comma_separator' ? de(0) : k === 'amount_no_decimals' ? n.toFixed(0) : n.toFixed(2)).replace(/<[^>]*>/g, '');
  };
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const sized = (url, w) => (url ? url.replace(/(\?|$)/, m => (m === '?' ? `?width=${w}&` : `?width=${w}`)) : '');
  // "Pflanzenhöhe 50 - 70cm | Topfdurchmesser 17cm" -> "50–70 cm, Topf Ø 17 cm"
  const variantLabel = t => {
    if (!t || t === 'Default Title') return '';
    const m = t.match(/Pflanzenhöhe\s*([\d\s\-–]+)\s*cm\s*\|\s*Topfdurchmesser\s*Ø?\s*(\d+)\s*cm/);
    return m ? `${m[1].replace(/\s/g, '').replace('-', '–')} cm, Topf Ø ${m[2]} cm` : t;
  };
  const shipMessage = total => (total >= FREE ? 'Dein Versand ist <strong>kostenlos</strong>.'
    : total === 0 ? `Ab ${money(FREE)} versenden wir kostenlos.`
    : `Noch <strong>${money(FREE - total)}</strong> bis zum kostenlosen Versand.`);
  const loadScript = (() => { const cache = {}; return src => (cache[src] ||= new Promise((res, rej) => { const s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); })); })();

  let toastTl;
  function toast(msg) {
    const el = $('[data-toast]');
    el.textContent = msg;
    toastTl?.kill();
    toastTl = gsap.timeline()
      .fromTo(el, { y: 24, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .3, ease: 'power3.out' })
      .to(el, { y: 24, autoAlpha: 0, duration: .25, ease: 'power2.in', delay: 2.4 });
  }

  /* ---------- Warenkorb (Shopify AJAX API) ---------- */
  let cart = null;
  const api = (url, body) => fetch(url, {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  }).then(async r => {
    const j = await r.json().catch(() => ({}));
    if (!r.ok) { const err = new Error(j.description || j.message || 'Fehler'); err.shop = typeof j.description === 'string' && j.description.length > 0; throw err; }
    return j;
  });
  // Shopify liefert verständliche Texte (z. B. Lagerbestand); sonst allgemeiner Hinweis
  const errorText = e => (e && e.shop ? e.message : 'Das hat nicht geklappt, bitte versuch es noch einmal');
  // Größenangaben (auch für Pflanzen mit nur einer Variante, aus Metafeldern) liefert der Abschnitt cart-meta
  let cartMeta = {};
  const loadCartMeta = () => fetch(`${R.root}?sections=cart-meta`).then(r => r.json()).then(j => {
    const t = document.createElement('template');
    t.innerHTML = j['cart-meta'] || '';
    cartMeta = JSON.parse(t.content.querySelector('[data-cart-meta]')?.textContent || '{}');
  }).catch(() => {});
  const sizeOf = item => cartMeta[item.key] || variantLabel(item.variant_title);
  const refreshCart = () => Promise.all([api(`${R.cart}.js`), loadCartMeta()]).then(([c]) => { cart = c; renderCart(); return c; });

  const lineHtml = item => `
    <li class="line">
      <img src="${sized(item.image, 200)}" alt="" width="96" height="120" loading="lazy">
      <div>
        <a class="line__title" href="${item.url}">${esc(item.product_title)}</a>
        ${sizeOf(item) ? `<p class="line__variant">${esc(sizeOf(item))}</p>` : ''}
        <div class="qty" role="group" aria-label="Anzahl ${esc(item.product_title)}">
          <button type="button" aria-label="Weniger" data-line-change="${item.key}" data-qty-to="${item.quantity - 1}">−</button>
          <output>${item.quantity}</output>
          <button type="button" aria-label="Mehr" data-line-change="${item.key}" data-qty-to="${item.quantity + 1}">+</button>
        </div>
      </div>
      <span class="line__price">${money(item.final_line_price)}</span>
    </li>`;

  function renderCart() {
    if (!cart) return;
    const n = cart.item_count;
    $$('[data-cart-count]').forEach(b => { b.textContent = n; b.hidden = n === 0; });
    const total = cart.total_price;
    const free = total >= FREE || total === 0;
    $$('[data-cart-ship]').forEach(el => { el.innerHTML = shipMessage(total); });
    $$('[data-cart-subtotal]').forEach(el => { el.textContent = money(total); });
    $$('[data-cart-shipping]').forEach(el => { el.textContent = free ? 'kostenlos' : money(SHIP); });
    $$('[data-checkout]').forEach(b => { b.disabled = n === 0; });
    $$('[data-cart-items]').forEach(list => {
      list.innerHTML = n ? cart.items.map(lineHtml).join('')
        : `<li class="drawer__empty"><p>Dein Warenkorb ist leer.</p><a class="btn btn--ghost" href="${R.root}collections/unsere-favoriten">Unsere Favoriten ansehen</a></li>`;
    });
    $$('[data-cart-express]').forEach(el => { el.hidden = n === 0; });
    renderUpsell();
  }

  /* ---------- Ergänzungen bis zum kostenlosen Versand ---------- */
  // Pflanzenliste kommt einmalig aus dem Abschnitt cart-upsell; je Pflanze wird die Größe gewählt,
  // die die Lücke zum Gratisversand am knappsten schließt (sonst die größte darunter).
  let upsellPool = null;
  const loadUpsell = () => upsellPool || (upsellPool = fetch(`${R.root}?sections=cart-upsell`).then(r => r.json()).then(j => {
    const t = document.createElement('template');
    t.innerHTML = j['cart-upsell'] || '';
    return JSON.parse(t.content.querySelector('[data-cart-upsell]')?.textContent || '[]');
  }).catch(() => []));
  async function renderUpsell() {
    const boxes = $$('[data-cart-upsell-box]');
    if (!boxes.length || !cart) return;
    const gap = FREE - cart.total_price;
    if (!cart.item_count || gap <= 0) { boxes.forEach(b => { b.hidden = true; }); return; }
    const total = cart.total_price;
    const pool = await loadUpsell();
    if (!cart || cart.total_price !== total) return; // Warenkorb hat sich inzwischen geändert
    const inCart = new Set(cart.items.map(i => i.product_id));
    const picks = pool.filter(p => !inCart.has(p.p) && p.v.length).map(p => {
      const vs = [...p.v].sort((a, b) => a.pr - b.pr);
      return { ...p, v: vs.find(v => v.pr >= gap) || vs[vs.length - 1] };
    });
    const closes = picks.filter(p => p.v.pr >= gap).sort((a, b) => a.v.pr - b.v.pr);
    const below = picks.filter(p => p.v.pr < gap).sort((a, b) => b.v.pr - a.v.pr);
    const list = [...closes, ...below].slice(0, 3);
    boxes.forEach(b => {
      b.hidden = !list.length;
      b.innerHTML = list.length ? `
        <p class="upsell__title">Mit einer dieser Pflanzen sparst du die Versandkosten</p>
        <ul class="upsell__list">${list.map(p => `
          <li class="upsell__item">
            <a href="${p.u}" tabindex="-1"><img src="${p.i}" alt="" width="48" height="60" loading="lazy"></a>
            <div>
              <a class="upsell__name" href="${p.u}">${esc(p.t)}</a>
              <span>${p.v.l ? `${esc(p.v.l)}, ` : ''}${money(p.v.pr)}${p.v.pr >= gap ? ' · <em>versandkostenfrei</em>' : ''}</span>
            </div>
            <button class="upsell__add" type="button" data-upsell-add="${p.v.id}" aria-label="${esc(p.t)} hinzufügen">+</button>
          </li>`).join('')}
        </ul>` : '';
    });
  }

  // variantId darf auch eine Liste sein (Set): dann landen alle Einzelpflanzen im Warenkorb
  async function addToCart(variantId, quantity, sourceImg, setInfo) {
    try {
      const ids = Array.isArray(variantId) ? variantId : [variantId];
      const res = await api(`${R.cartAdd}.js`, { items: ids.map(id => ({ id: Number(id), quantity })) });
      const item = setInfo ? { ...setInfo, key: '', variant_title: '' } : (res.items?.[0] || res);
      await refreshCart();
      flyToCart(sourceImg);
      showAdded(item, quantity);
      return item;
    } catch (e) {
      toast(errorText(e));
      throw e;
    }
  }

  function flyToCart(sourceImg) {
    const target = $('.cart-btn');
    showNav();
    if (!sourceImg || reducedMotion || !sourceImg.getBoundingClientRect().width) return pulseCart();
    const from = sourceImg.getBoundingClientRect();
    const to = target.getBoundingClientRect();
    const clone = sourceImg.cloneNode();
    clone.className = 'fly';
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    Object.assign(clone.style, { left: from.left + 'px', top: from.top + 'px', width: from.width + 'px', height: from.height + 'px' });
    document.body.appendChild(clone);
    gsap.timeline({ onComplete: () => { clone.remove(); pulseCart(); } })
      .to(clone, {
        x: to.left + to.width / 2 - (from.left + from.width / 2),
        y: to.top + to.height / 2 - (from.top + from.height / 2),
        scale: 28 / from.width, borderRadius: '50%', duration: .75, ease: 'power2.inOut',
      })
      .to(clone, { opacity: 0, duration: .15 }, '-=.15');
  }
  const pulseCart = () => gsap.fromTo('[data-cart-count]', { scale: 1.6 }, { scale: 1, duration: .5, ease: 'back.out(3)' });

  // Bestätigung nach dem Hinzufügen mit direktem Weg zum Warenkorb
  const added = $('[data-added]');
  let addedTimer, addedHover = false;
  function showAdded(item, qty) {
    if (!added) return;
    const label = sizeOf(item);
    $('[data-added-item]').innerHTML = `
      <img src="${sized(item.image || item.featured_image?.url, 160)}" alt="" width="64" height="80">
      <div><strong>${esc(item.product_title)}</strong><span>${label ? `${esc(label.split(',')[0])}, ` : ''}${qty} Stück</span></div>
      <strong>${money(item.price * qty)}</strong>`;
    $('[data-added-ship]').innerHTML = shipMessage(cart.total_price);
    $('[data-added-open]').textContent = `Warenkorb (${cart.item_count})`;
    const wasHidden = added.hidden;
    added.hidden = false;
    if (wasHidden) gsap.fromTo(added, { y: window.innerWidth <= 600 ? 40 : -12, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: dur(.4), ease: 'power3.out', delay: reducedMotion ? 0 : .35 });
    else gsap.fromTo(added, { scale: .98 }, { scale: 1, duration: dur(.25) });
    clearTimeout(addedTimer);
    addedTimer = setTimeout(() => { if (!addedHover) hideAdded(); }, 6000);
  }
  function hideAdded() {
    clearTimeout(addedTimer);
    if (!added || added.hidden) return;
    gsap.to(added, { autoAlpha: 0, y: window.innerWidth <= 600 ? 40 : -12, duration: dur(.25), ease: 'power2.in', onComplete: () => { added.hidden = true; } });
  }
  added?.addEventListener('pointerenter', () => { addedHover = true; clearTimeout(addedTimer); });
  added?.addEventListener('pointerleave', () => { addedHover = false; addedTimer = setTimeout(hideAdded, 2500); });

  /* ---------- Navigation und Overlays ---------- */
  const nav = $('[data-nav]');
  const navBar = $('.nav__bar');
  const scrim = $('[data-scrim]');
  const mega = $('[data-mega]');
  const searchPanel = $('[data-search]');
  const drawer = $('[data-cart-drawer]');
  const mmenu = $('[data-mmenu]');
  const root = document.documentElement;
  let overlay = null;
  let lastFocus = null;

  function openOverlay(name) {
    if (overlay === name) return;
    hideAdded();
    if (overlay) closeOverlay(true);
    overlay = name;
    lastFocus = document.activeElement;
    showNav();
    scrim.hidden = false;
    scrim.style.zIndex = name === 'cart' ? 60 : 45;
    gsap.fromTo(scrim, { opacity: 0 }, { opacity: 1, duration: dur(.25) });

    if (name === 'mega') {
      mega.hidden = false;
      $('[data-mega-toggle]').setAttribute('aria-expanded', 'true');
      gsap.timeline()
        .fromTo('.mega__inner', { clipPath: 'inset(0% 0% 100% 0% round 28px)', y: -8 }, { clipPath: 'inset(0% 0% 0% 0% round 28px)', y: 0, duration: dur(.45), ease: 'power3.out' })
        .fromTo('.mega__group > *', { y: 10, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: dur(.35), stagger: .02, ease: 'power2.out' }, '-=.3')
        .fromTo('.mega__feature img', { y: 40, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: dur(.5), ease: 'power3.out' }, '-=.35');
    }
    if (name === 'search') {
      searchPanel.hidden = false;
      // Sichtbar schalten bevor fokussiert wird (ein unsichtbares Feld nimmt keinen Fokus an)
      gsap.fromTo('.search__inner', { y: -10, opacity: 0, visibility: 'visible' }, { y: 0, opacity: 1, duration: dur(.3), ease: 'power3.out' });
      const input = $('[data-search-input]');
      input.focus();
      input.select();
    }
    if (name === 'cart') {
      drawer.hidden = false;
      document.body.classList.add('is-locked');
      gsap.fromTo(drawer, { xPercent: 100 }, { xPercent: 0, duration: dur(.45), ease: 'power3.out' });
      $('[data-cart-close]', drawer).focus({ preventScroll: true, focusVisible: false });
      refreshCart();
    }
    if (name === 'mmenu') {
      // Kopfzeile genau dort, wo die Navigation gerade steht, damit das Logo nicht springt
      // (nav statt navBar: die Leiste kann gerade noch nach oben verschoben sein)
      $('.mmenu__head').style.marginTop = `${Math.max(0, nav.getBoundingClientRect().top)}px`;
      mmenu.hidden = false;
      document.body.classList.add('is-locked');
      $('[data-mobile-open]').setAttribute('aria-expanded', 'true');
      gsap.timeline()
        .fromTo(mmenu, { clipPath: 'circle(0% at 40px 44px)' }, { clipPath: 'circle(150% at 40px 44px)', duration: dur(.55), ease: 'power3.inOut' })
        .fromTo('.mmenu__scroll > *', { y: 16, autoAlpha: 0 }, { y: 0, autoAlpha: 1, stagger: .04, duration: dur(.4), ease: 'power2.out' }, '-=.3')
        .fromTo('.mmenu__tile', { scale: .94, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, stagger: .04, duration: dur(.35), ease: 'power2.out' }, '-=.45');
      $('[data-mobile-close]').focus({ preventScroll: true, focusVisible: false });
    }
  }

  function closeOverlay(instant = false) {
    const name = overlay;
    if (!name) return;
    overlay = null;
    const d = instant ? 0 : dur(.25);
    gsap.to(scrim, { opacity: 0, duration: d, onComplete: () => { if (!overlay) scrim.hidden = true; } });
    if (name === 'mega') {
      $('[data-mega-toggle]').setAttribute('aria-expanded', 'false');
      gsap.to('.mega__inner', { clipPath: 'inset(0% 0% 100% 0% round 28px)', duration: d, ease: 'power2.in', onComplete: () => { if (overlay !== 'mega') mega.hidden = true; } });
    }
    if (name === 'search') gsap.to('.search__inner', { y: -10, autoAlpha: 0, duration: d, onComplete: () => { if (overlay !== 'search') searchPanel.hidden = true; } });
    if (name === 'cart') {
      document.body.classList.remove('is-locked');
      gsap.to(drawer, { xPercent: 100, duration: instant ? 0 : dur(.35), ease: 'power3.in', onComplete: () => { if (overlay !== 'cart') drawer.hidden = true; } });
    }
    if (name === 'mmenu') {
      document.body.classList.remove('is-locked');
      $('[data-mobile-open]').setAttribute('aria-expanded', 'false');
      gsap.to(mmenu, { clipPath: 'circle(0% at 40px 44px)', duration: instant ? 0 : dur(.45), ease: 'power3.inOut', onComplete: () => { if (overlay !== 'mmenu') mmenu.hidden = true; } });
    }
    if (!instant) lastFocus?.focus?.({ preventScroll: true });
  }

  // Navigation verschwindet beim Runterscrollen; klebende Elemente folgen über --nav-offset
  let navHidden = false;
  function showNav() {
    if (!navHidden) return;
    navHidden = false;
    gsap.to(navBar, { y: 0, duration: dur(.35), ease: 'power3.out' });
    gsap.to(root, { '--nav-offset': `${navBar.offsetHeight + 12}px`, duration: dur(.35), ease: 'power3.out' });
  }
  function hideNav() {
    if (navHidden || overlay) return;
    navHidden = true;
    gsap.to(navBar, { y: -(navBar.offsetHeight + 90), duration: dur(.35), ease: 'power3.in' });
    gsap.to(root, { '--nav-offset': '0px', duration: dur(.35), ease: 'power3.in' });
  }
  ScrollTrigger.create({ start: 0, end: 'max', onUpdate: self => { if (self.direction === 1 && self.scroll() > 320) hideNav(); else if (self.direction === -1) showNav(); } });
  window.addEventListener('resize', () => { if (!navHidden) root.style.setProperty('--nav-offset', `${navBar.offsetHeight + 12}px`); });

  // Hover-Pille zwischen den Menüpunkten
  const pill = $('[data-nav-pill]');
  let pillVisible = false;
  $$('.nav__link').forEach(link => link.addEventListener('pointerenter', () => {
    gsap.to(pill, { x: link.offsetLeft, width: link.offsetWidth, opacity: 1, duration: pillVisible ? dur(.35) : 0, ease: 'power3.out' });
    pillVisible = true;
  }));
  $('.nav__links')?.addEventListener('pointerleave', () => { pillVisible = false; gsap.to(pill, { opacity: 0, duration: dur(.2) }); });

  // Mega-Menü: Hover mit kurzer Verzögerung, Klick und Tastatur
  let megaTimer;
  if (canHover && mega) {
    $('[data-mega-toggle]').addEventListener('pointerenter', () => { clearTimeout(megaTimer); megaTimer = setTimeout(() => openOverlay('mega'), 120); });
    nav.addEventListener('pointerleave', () => { clearTimeout(megaTimer); if (overlay === 'mega') megaTimer = setTimeout(() => closeOverlay(), 220); });
    nav.addEventListener('pointerenter', () => { if (overlay === 'mega') clearTimeout(megaTimer); });
    // Zeiger wandert in der Leiste zu einem anderen Punkt (Magazin, Suche, Logo …): Menü schließen bzw. nicht mehr öffnen
    nav.addEventListener('pointerover', (e) => {
      if (e.pointerType === 'touch' || e.target === nav) return;
      if (e.target.closest('[data-mega-toggle], [data-mega]')) { if (overlay === 'mega') clearTimeout(megaTimer); return; }
      clearTimeout(megaTimer);
      if (overlay === 'mega') megaTimer = setTimeout(() => closeOverlay(), 180);
    });
  }

  /* ---------- Sofortsuche (Shopify Predictive Search) ---------- */
  const resultsBox = $('[data-search-results]');
  const defaultResults = resultsBox?.innerHTML || '';
  const mark = (text, q) => {
    const i = text.toLowerCase().indexOf(q.toLowerCase());
    return i < 0 ? esc(text) : esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length));
  };
  let searchCtrl, searchTimer;
  async function runSearch(q) {
    if (!q.trim()) { resultsBox.innerHTML = defaultResults; return; }
    searchCtrl?.abort();
    searchCtrl = new AbortController();
    const url = `${R.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last`;
    try {
      const { resources: { results: r } } = await fetch(url, { signal: searchCtrl.signal }).then(x => x.json());
      const products = r.products || [], collections = r.collections || [], articles = r.articles || [];
      if (!products.length && !collections.length && !articles.length) {
        resultsBox.innerHTML = `<p class="search__empty">Keine Treffer für „${esc(q)}“. Versuch es mit einem Pflanzennamen wie Monstera oder Calathea.</p>`;
        return;
      }
      resultsBox.innerHTML = `
        ${products.length ? `<div><p class="search__label">Pflanzen</p><div class="search__products">${products.map(p => `
          <a class="search-hit" href="${p.url}"><img src="${sized(p.image || p.featured_image?.url, 120)}" alt="" width="48" height="60" loading="lazy">
          <span><strong>${mark(p.title, q)}</strong><span>${p.available ? `${p.price_min !== p.price_max ? 'ab ' : ''}${money(Math.round(parseFloat(p.price_min || p.price) * 100))}` : 'Ausverkauft'}</span></span></a>`).join('')}</div></div>` : ''}
        ${collections.length ? `<div><p class="search__label">Kategorien</p><div class="search__chips">${collections.map(c => `<a class="chip" href="${c.url}">${mark(c.title, q)}</a>`).join('')}</div></div>` : ''}
        ${articles.length ? `<div class="search__articles"><p class="search__label">Ratgeber</p>${articles.slice(0, 4).map(a => `<a href="${a.url}">${mark(a.title, q)}</a>`).join('')}</div>` : ''}
        <a class="text-link" href="${R.search}?q=${encodeURIComponent(q)}&options[prefix]=last">Alle Ergebnisse anzeigen</a>`;
    } catch (e) { if (e.name !== 'AbortError') resultsBox.innerHTML = defaultResults; }
  }
  $('[data-search-input]')?.addEventListener('input', e => { clearTimeout(searchTimer); searchTimer = setTimeout(() => runSearch(e.target.value), 120); });

  /* ---------- Inhaltsverzeichnis für lange Texte ---------- */
  let tocId = 0;
  function initToc(scope = document) {
    $$('[data-longread]', scope).forEach(box => {
      const content = $('.rte', box);
      if (!content) return;
      const isArticle = box.classList.contains('article__body');
      const heads = $$(isArticle ? 'h2' : 'h2, h3', content);
      if (heads.length < 3) return;
      heads.forEach(h => { if (!h.id) h.id = `abschnitt-${++tocId}`; });
      const toc = document.createElement('nav');
      toc.className = 'toc';
      toc.setAttribute('aria-label', 'Inhalt');
      toc.innerHTML = '<p>Inhalt</p>' + heads.map(h => `<a href="#${h.id}">${esc(h.textContent.trim())}</a>`).join('');
      if (isArticle) box.firstElementChild.replaceWith(toc);
      else {
        // Überschrift wandert über den Text, links steht das Verzeichnis
        const titleCol = box.firstElementChild;
        const title = $('.longread__title', titleCol);
        box.classList.remove('longread--plain');
        const right = document.createElement('div');
        if (title) right.appendChild(title);
        right.appendChild(content);
        titleCol.replaceWith(toc);
        box.appendChild(right);
      }
      const links = $$('a', toc);
      links.forEach((a, i) => {
        a.addEventListener('click', e => { e.preventDefault(); scrollToEl(heads[i]); history.replaceState(null, '', `#${heads[i].id}`); });
        ScrollTrigger.create({
          trigger: heads[i], start: 'top 40%',
          endTrigger: heads[i + 1] || content, end: heads[i + 1] ? 'top 40%' : 'bottom 40%',
          onToggle: self => { if (self.isActive) { links.forEach(l => l.classList.remove('is-active')); a.classList.add('is-active'); } },
        });
      });
    });
  }
  function scrollToEl(el) {
    if (!el) return;
    window.scrollTo({ top: el.getBoundingClientRect().top + scrollY - (navBar.offsetHeight + 28), behavior: reducedMotion ? 'auto' : 'smooth' });
  }

  /* ---------- Startseite: Hero mit Fensterlicht ---------- */
  function initHero() {
    const hero = $('[data-hero]');
    if (!hero) return;
    gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
      const split = SplitText.create('[data-hero-title]', { type: 'lines', mask: 'lines', autoSplit: true });
      gsap.timeline({ defaults: { ease: 'power3.out' } })
        .from(split.lines, { yPercent: 105, duration: .7, stagger: .06 })
        .from('[data-hero-fade]', { y: 14, autoAlpha: 0, duration: .45, stagger: .05 }, .25)
        .from('[data-hero-plant]', { y: 30, autoAlpha: 0, duration: .9, ease: 'power2.out' }, .1)
        .from('[data-hero-tag], [data-hero-switch] > *', { y: 14, autoAlpha: 0, duration: .4, stagger: .05 }, .5);
      return () => split.revert();
    });

    const plant = $('[data-hero-plant]', hero);
    const canvas = $('[data-light]', hero);
    if (!plant) return;
    const plants = $$('[data-plant-data]', hero).map(t => t.dataset);
    let current = 0, switching = false, light = null;

    $('[data-hero-switch]', hero)?.addEventListener('click', async e => {
      const b = e.target.closest('[data-plant]');
      if (!b || switching) return;
      const i = Number(b.dataset.plant);
      if (i === current) return;
      switching = true;
      current = i;
      const p = plants[i];
      $$('[data-plant]', hero).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      if (light) gsap.to(light.uniforms.uPlantMix, { value: 0, duration: dur(.25), onUpdate: () => light.renderOnce() });
      await gsap.to(plant, { y: 24, autoAlpha: 0, duration: dur(.3), ease: 'power2.in' });
      plant.srcset = `${p.src} 600w, ${p.srcLarge} 1000w`;
      plant.src = p.src;
      plant.alt = p.title;
      await plant.decode().catch(() => {});
      const tag = $('[data-hero-tag]', hero);
      tag.href = p.url;
      tag.innerHTML = `<strong>${esc(p.title)}</strong><span>${esc(p.price)}</span>`;
      gsap.fromTo(tag, { y: 8, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: dur(.35) });
      gsap.set(plant, { y: 0 });
      if (light) await light.setPlant(plant, p.src);
      gsap.fromTo(plant, { y: 24 }, { y: 0, autoAlpha: 1, duration: dur(.5), ease: 'power3.out' });
      if (light) gsap.to(light.uniforms.uPlantMix, { value: 1, duration: dur(.6), delay: .15, onUpdate: () => light.renderOnce() });
      switching = false;
    });

    // Lichteffekt (Three.js) laden und einblenden
    // Auf Touch-Geräten ohne Dauer-Animation: neu gezeichnet wird nur beim Scrollen
    const start = () => loadScript(window.MZ.assets.light)
      .then(() => window.MZLight.init(canvas, { reducedMotion, animate: canHover }))
      .then(async inst => {
        if (!inst) return;
        light = inst;
        const u = inst.uniforms;
        await inst.setPlant(plant, plants[current]?.src || plant.currentSrc);
        setTimeout(() => inst.measurePlant(), 1400);
        gsap.to(canvas, { opacity: 1, duration: .8, ease: 'power1.out' });
        gsap.to(u.uPlantMix, { value: 1, duration: dur(1.2), onUpdate: () => inst.renderOnce() });
        const sunX = gsap.quickTo(u.uSun.value, 'x', { duration: 1.2, ease: 'power3', onUpdate: () => inst.renderOnce() });
        const sunY = gsap.quickTo(u.uSun.value, 'y', { duration: 1.2, ease: 'power3' });
        const plantX = gsap.quickTo(plant, 'x', { duration: 1.2, ease: 'power3', onUpdate: () => inst.measurePlant() });
        if (!reducedMotion && canHover) {
          hero.addEventListener('pointermove', e => {
            const r = hero.getBoundingClientRect();
            const nx = ((e.clientX - r.left) / r.width) * 2 - 1;
            sunX(nx);
            sunY(((e.clientY - r.top) / r.height) * 2 - 1);
            plantX(nx * -8);
          });
        }
        ScrollTrigger.create({
          trigger: hero, start: 'top top', end: 'bottom top', scrub: reducedMotion ? true : 1,
          onUpdate: self => { u.uDay.value = .35 + self.progress * .65; inst.renderOnce(); },
        });
      }).catch(() => {});
    // Lichteffekt sofort starten (die Dateien werden auf der Startseite per Preload schon früh geladen)
    start();
  }

  /* ---------- Kategorieseite: Filter und Sortierung ohne Neuladen ---------- */
  function initCollection() {
    const grid = $('[data-grid]');
    const onlyAvail = $('[data-only-available]');
    const sort = $('[data-sort]');
    if (!grid || !onlyAvail || !sort) return;
    const cards = $$('.card', grid);
    const original = cards.slice();
    const countEl = $('[data-count]');
    let first = true;
    function render() {
      let list = original.slice();
      if (sort.value === 'price-asc') list.sort((a, b) => a.dataset.price - b.dataset.price);
      if (sort.value === 'price-desc') list.sort((a, b) => b.dataset.price - a.dataset.price);
      if (sort.value === 'new') list.sort((a, b) => b.dataset.created - a.dataset.created);
      list.sort((a, b) => (b.dataset.available === 'true') - (a.dataset.available === 'true'));
      const state = first || reducedMotion ? null : Flip.getState(cards, { props: 'opacity' });
      if (state) grid.style.minHeight = grid.offsetHeight + 'px';
      list.forEach(c => { c.hidden = onlyAvail.checked && c.dataset.available !== 'true'; grid.appendChild(c); });
      const visible = list.filter(c => !c.hidden).length;
      if (countEl) countEl.textContent = `${visible} ${visible === 1 ? 'Pflanze' : 'Pflanzen'}`;
      const empty = $('[data-grid-empty]');
      if (empty) empty.hidden = visible > 0 || !original.length;
      if (state) {
        Flip.from(state, {
          duration: .55, ease: 'power2.inOut', absolute: true, scale: true,
          onEnter: els => gsap.fromTo(els, { opacity: 0, scale: .94 }, { opacity: 1, scale: 1, duration: .4 }),
          onLeave: els => gsap.to(els, { opacity: 0, scale: .94, duration: .3 }),
          onComplete: () => { grid.style.minHeight = ''; ScrollTrigger.refresh(); },
        });
      } else if (!first) ScrollTrigger.refresh();
      first = false;
    }
    onlyAvail.addEventListener('change', render);
    sort.addEventListener('change', render);
    render();
  }

  /* ---------- Produktseite ---------- */
  function initProduct() {
    const root = $('[data-product-section]');
    if (!root) return;
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const qtyInput = $('[data-qty-input]', root);
    const mainImg = $('.gallery__main img', root);
    const zoom = $('[data-zoom]', root);
    const sizes = $$('[data-variant]', root);
    const thumbs = $$('.gallery__thumb', root);
    const stock = $('[data-stock]', root);
    const addBtns = [$('[data-add]', root), $('[data-add-sticky]', root)].filter(Boolean);
    let qty = 1;
    let price = Number(($('[data-variant][aria-pressed="true"]', root) || {}).dataset?.price) || null;
    let available = !$('[data-add]', root)?.disabled;
    // Set: Der Knopf legt die Einzelpflanzen aus data-set-items in den Warenkorb
    const setBox = $('[data-set-items]', root);
    const setIds = setBox ? setBox.dataset.setItems.split(',').filter(Boolean) : null;
    const add = img => setIds
      ? addToCart(setIds, qty, img, { product_title: $('h1', root).textContent.trim(), image: mainImg?.currentSrc || mainImg?.src, price })
      : addToCart(idInput.value, qty, img);

    function updateShip() {
      const box = $('[data-buy-ship]', root);
      if (!box || !cart || price === null) return;
      // Ausverkauft: kein Versandversprechen anzeigen
      box.hidden = !available;
      if (!available) { box.innerHTML = ''; return; }
      const inCart = cart.items.some(i => String(i.variant_id) === idInput.value);
      const after = cart.total_price + (inCart ? 0 : price * qty);
      box.innerHTML = after >= FREE
        ? (inCart ? 'Dein Versand ist <strong>kostenlos</strong>.' : 'Mit diesem Produkt ist dein Versand <strong>kostenlos</strong>.')
        : `Noch ${money(FREE - after)} bis zum kostenlosen Versand, sonst ${money(SHIP)}.`;
    }
    if (price === null) {
      const p = $('[data-price]', root).textContent.replace(/[^\d,]/g, '').replace(',', '.');
      price = Math.round(parseFloat(p) * 100) || 0;
    }

    function setVariant(btn) {
      sizes.forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
      idInput.value = btn.dataset.variant;
      price = Number(btn.dataset.price);
      available = btn.dataset.sold !== 'true';
      const priceEl = $('[data-price]', root);
      priceEl.textContent = money(price);
      const cmp = $('[data-compare]', root), cmpVal = Number(btn.dataset.compare);
      if (cmp) { cmp.hidden = !(cmpVal > price); cmp.textContent = cmpVal > price ? money(cmpVal) : ''; }
      $('[data-sticky-price]', root).textContent = money(price);
      const sSize = $('[data-sticky-size]', root);
      if (sSize) sSize.textContent = btn.dataset.label;
      const fh = $('[data-fact-height]', root), fp = $('[data-fact-pot]', root);
      if (fh) fh.textContent = btn.dataset.label;
      if (fp) fp.textContent = btn.dataset.sub.replace('Topf ', '');
      gsap.fromTo(priceEl, { y: -6, opacity: .4 }, { y: 0, opacity: 1, duration: dur(.35), ease: 'power2.out' });
      stock.textContent = available ? `Auf Lager, Zustellung in ca. ${stock.dataset.delivery}` : 'Diese Größe ist gerade ausverkauft';
      stock.classList.toggle('is-sold', !available);
      addBtns.forEach(b => { b.disabled = !available; b.textContent = available ? 'In den Warenkorb' : 'Ausverkauft'; });
      const url = new URL(location.href);
      url.searchParams.set('variant', btn.dataset.variant);
      history.replaceState(null, '', url);
      // Nur die Fotos der gewählten Größe (plus allgemeine Fotos) zeigen
      if (grouped && btn.dataset.media) {
        $$('[data-thumb][data-group]', root).forEach(b => { b.hidden = !!b.dataset.group && b.dataset.group !== btn.dataset.media; });
      }
      // Eigenes Variantenbild zeigen, falls hinterlegt
      const vThumb = btn.dataset.media && thumbs.find(t => t.dataset.mediaId === btn.dataset.media);
      if (vThumb && Number(vThumb.dataset.thumb) !== imgIndex) setImage(Number(vThumb.dataset.thumb));
      updateShip();
    }

    const grouped = !!$('.gallery__thumbs[data-grouped]', root);
    let imgIndex = Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-current') === 'true'));
    // Wischen springt nur zwischen sichtbaren Fotos
    function stepImage(dir) {
      const vis = thumbs.filter(t => !t.hidden);
      if (!vis.length) return;
      const pos = vis.indexOf(thumbs[imgIndex]);
      setImage(Number(vis[(pos + dir + vis.length) % vis.length].dataset.thumb));
    }
    function setImage(i) {
      if (!thumbs.length) return;
      imgIndex = (i + thumbs.length) % thumbs.length;
      const t = thumbs[imgIndex];
      zoom.classList.remove('is-zoomed');
      gsap.to(mainImg, { opacity: 0, duration: dur(.15), onComplete: () => { mainImg.srcset = t.dataset.srcset; mainImg.src = t.dataset.src; gsap.to(mainImg, { opacity: 1, duration: dur(.3) }); } });
      $$('[data-thumb]', root).forEach(b => b.setAttribute('aria-current', String(Number(b.dataset.thumb) === imgIndex)));
    }

    root.addEventListener('click', e => {
      const t = e.target.closest('[data-variant],[data-thumb],[data-qty],[data-add-sticky],[data-set-box] [data-add]');
      if (!t) return;
      if (t.dataset.variant) setVariant(t);
      else if (t.dataset.thumb !== undefined) setImage(Number(t.dataset.thumb));
      else if (t.dataset.qty) { qty = Math.max(1, qty + Number(t.dataset.qty)); $('[data-qty-value]', root).textContent = qty; qtyInput.value = qty; updateShip(); }
      else if (t.hasAttribute('data-add-sticky') && !t.disabled) add($('.sticky-buy__img', root)).then(updateShip).catch(() => {});
      else if (t.hasAttribute('data-add') && !t.disabled) {
        t.setAttribute('aria-busy', 'true');
        add(mainImg).then(updateShip).catch(() => {}).finally(() => t.removeAttribute('aria-busy'));
      }
    });
    form?.addEventListener('submit', e => {
      e.preventDefault();
      if (!available) return;
      const btn = $('[data-add]', root);
      btn.setAttribute('aria-busy', 'true');
      addToCart(idInput.value, qty, mainImg).then(updateShip).catch(() => {}).finally(() => btn.removeAttribute('aria-busy'));
    });

    // Zoom und Wischen
    const moveZoom = e => {
      const r = zoom.getBoundingClientRect();
      zoom.style.setProperty('--zx', ((e.clientX - r.left) / r.width) * 100 + '%');
      zoom.style.setProperty('--zy', ((e.clientY - r.top) / r.height) * 100 + '%');
    };
    if (zoom) {
      zoom.addEventListener('click', e => { if (window.matchMedia('(max-width: 900px)').matches) return; zoom.classList.toggle('is-zoomed'); moveZoom(e); });
      zoom.addEventListener('pointermove', e => { if (zoom.classList.contains('is-zoomed')) moveZoom(e); });
      zoom.addEventListener('pointerleave', () => zoom.classList.remove('is-zoomed'));
      let startX = null;
      zoom.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      zoom.addEventListener('touchend', e => { if (startX === null) return; const dx = e.changedTouches[0].clientX - startX; if (Math.abs(dx) > 40) stepImage(dx < 0 ? 1 : -1); startX = null; });
    }

    // Mitlaufende Kaufleiste, sobald der Kaufen-Button aus dem Bild ist
    const sticky = $('[data-sticky-buy]', root);
    if (sticky) {
      gsap.set(sticky, { y: 0, yPercent: 160, autoAlpha: 0 });
      ScrollTrigger.create({
        trigger: '[data-buy-row]', start: 'bottom top+=60', endTrigger: 'html', end: 'bottom bottom',
        onToggle: self => {
          gsap.to(sticky, { yPercent: self.isActive ? 0 : 160, autoAlpha: self.isActive ? 1 : 0, duration: dur(.4), ease: self.isActive ? 'power3.out' : 'power2.in' });
          sticky.setAttribute('aria-hidden', String(!self.isActive));
          $('[data-add-sticky]', root).tabIndex = self.isActive ? 0 : -1;
        },
      });
    }
    cartReady.then(updateShip);
  }

  // Ähnliche Produkte nachladen (Shopify Product Recommendations)
  function initRecommendations() {
    $$('[data-recommendations]').forEach(box => {
      if (box.children.length) return;
      fetch(box.dataset.url).then(r => r.text()).then(html => {
        const t = document.createElement('template');
        t.innerHTML = html;
        const inner = $('[data-recommendations]', t.content);
        if (inner?.children.length) { box.innerHTML = inner.innerHTML; ScrollTrigger.refresh(); }
      }).catch(() => {});
    });
  }

  /* ---------- Artikel ---------- */
  function initArticle() {
    const content = $('[data-article-content]');
    if (!content) return;
    // Ohne Beitragsbild wird ein Bild am Textanfang zum Titelbild (mit Beitragsbild blendet CSS die Dopplung aus)
    const firstEl = content.firstElementChild;
    if (!$('[data-article-hero]') && firstEl?.matches('p') && firstEl.querySelector('img') && !firstEl.textContent.trim()) {
      const hero = document.createElement('div');
      hero.className = 'article__hero';
      const im = firstEl.querySelector('img');
      im.removeAttribute('style');
      hero.appendChild(im);
      $('.article__head').after(hero);
      firstEl.remove();
    }
    // Tabellen wischbar machen: vorhandene Hülle (<div style="overflow-x:auto">) übernehmen, sonst eine anlegen
    $$('table', content).forEach(table => {
      let box = table.parentElement;
      if (!(box !== content && box.tagName === 'DIV' && box.children.length === 1)) {
        box = document.createElement('div');
        table.before(box);
        box.appendChild(table);
      }
      box.removeAttribute('style');
      box.className = 'table-scroll';
      box.tabIndex = 0;
      box.setAttribute('role', 'region');
      box.setAttribute('aria-label', 'Tabelle, seitlich wischbar');
    });
    // Kaufleiste direkt unter Pflanzenbildern, die auf ein Produkt verlinken (je Pflanze nur am ersten Bild)
    const shotHandles = new Set();
    $$('p', content).filter(p => p.children.length === 1 && p.firstElementChild.matches('a[href*="/products/"]') && p.querySelector('img') && !p.textContent.trim()).forEach(p => {
      const link = p.firstElementChild;
      const handle = new URL(link.href, location.origin).pathname.split('/products/')[1]?.split(/[/?#]/)[0];
      if (!handle || shotHandles.has(handle)) return;
      shotHandles.add(handle);
      fetch(`${R.root}products/${handle}.js`).then(r => (r.ok ? r.json() : null)).then(prod => {
        const variants = (prod?.variants || []).filter(v => v.available);
        if (!variants.length || prod.tags?.includes('buendel')) return;
        let current = variants.reduce((a, b) => (b.price < a.price ? b : a));
        const shot = document.createElement('div');
        shot.className = 'shot';
        p.replaceWith(shot);
        shot.append(link);
        shot.insertAdjacentHTML('beforeend', `<div class="shot__bar">
          <div class="shot__name">${esc(prod.title)}</div>
          ${variants.length > 1 ? `<div class="shot__sizes" role="group" aria-label="Größe">${variants.map(v => `<button type="button" class="chip" data-shot-size="${v.id}" aria-pressed="${v.id === current.id}">${esc(variantLabel(v.title).split(',')[0])}</button>`).join('')}</div>` : ''}
          <button type="button" class="btn btn--primary shot__add" data-shot-add>In den Warenkorb <span class="shot__price">${money(current.price)}</span></button>
          <div class="shot__note">inkl. MwSt., zzgl. Versand</div>
        </div>`);
        shot.addEventListener('click', e => {
          const size = e.target.closest('[data-shot-size]');
          if (size) {
            current = variants.find(v => String(v.id) === size.dataset.shotSize);
            $$('[data-shot-size]', shot).forEach(b => b.setAttribute('aria-pressed', b === size));
            $('.shot__price', shot).textContent = money(current.price);
            return;
          }
          const add = e.target.closest('[data-shot-add]');
          if (!add) return;
          add.disabled = true;
          addToCart(current.id, 1, $('img', shot)).catch(() => {}).finally(() => { add.disabled = false; });
        });
        ScrollTrigger.refresh();
      }).catch(() => {});
    });

    gsap.to('[data-progress]', { scaleX: 1, ease: 'none', scrollTrigger: { trigger: content, start: 'top 30%', end: 'bottom bottom', scrub: true } });

    // Pflanzen, die im Artikel verlinkt sind, als Karten unter dem Text
    const handles = [...new Set($$('a[href*="/products/"]', content).map(a => new URL(a.href, location.origin)).filter(u => u.hostname === location.hostname || u.hostname.endsWith('myzimmerpflanze.de')).map(u => u.pathname.split('/products/')[1]?.split(/[/?#]/)[0]).filter(Boolean))].slice(0, 8);
    if (!handles.length) return;
    Promise.all(handles.map(h => fetch(`${R.root}products/${h}?section_id=product-card-ajax`).then(r => (r.ok ? r.text() : '')).catch(() => '')))
      .then(parts => {
        const t = document.createElement('template');
        t.innerHTML = parts.join('');
        const cardsEl = $$('.card', t.content).sort((a, b) => (b.dataset.available === 'true') - (a.dataset.available === 'true'));
        if (!cardsEl.length) return;
        $('[data-article-products-grid]').append(...cardsEl);
        $('[data-article-products]').hidden = false;
        ScrollTrigger.refresh();
      });
  }

  // Zweites Produktbild erst beim ersten Überfahren laden (spart auf Handys alle Hover-Bilder)
  if (canHover) {
    document.addEventListener('pointerover', e => {
      const media = e.target.closest?.('.card__media');
      const hoverImg = media?.querySelector('img[data-hover-src]');
      if (!hoverImg) return;
      hoverImg.src = hoverImg.dataset.hoverSrc;
      hoverImg.removeAttribute('data-hover-src');
      hoverImg.hidden = false;
    });
  }

  /* ---------- Globale Ereignisse ---------- */
  document.addEventListener('click', e => {
    const t = e.target;
    const quick = t.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      addToCart(quick.dataset.quickAdd, 1, quick.closest('.card')?.querySelector('.card__media img')).catch(() => {}).finally(() => { quick.disabled = false; });
      return;
    }
    const scrollLink = t.closest('[data-scroll-to]');
    if (scrollLink) {
      const target = document.getElementById(scrollLink.dataset.scrollTo);
      if (target) { e.preventDefault(); scrollToEl(target); }
      return;
    }
    if (t.closest('[data-mega-toggle]')) { overlay === 'mega' ? closeOverlay() : openOverlay('mega'); return; }
    if (t.closest('[data-search-open]')) { openOverlay('search'); return; }
    if (t.closest('[data-search-close]')) { closeOverlay(); return; }
    if (t.closest('[data-cart-open]')) { openOverlay('cart'); return; }
    if (t.closest('[data-cart-close]') || t === scrim) { closeOverlay(); return; }
    if (t.closest('[data-mobile-open]')) { openOverlay('mmenu'); return; }
    if (t.closest('[data-mobile-close]')) { closeOverlay(); return; }
    if (t.closest('[data-added-open]')) { hideAdded(); openOverlay('cart'); return; }
    if (t.closest('[data-added-close]')) { hideAdded(); return; }
    const upAdd = t.closest('[data-upsell-add]');
    if (upAdd) {
      upAdd.disabled = true;
      api(`${R.cartAdd}.js`, { items: [{ id: Number(upAdd.dataset.upsellAdd), quantity: 1 }] })
        .then(() => refreshCart())
        .then(() => pulseCart())
        .catch(e => { toast(errorText(e)); upAdd.disabled = false; });
      return;
    }
    if (t.closest('[data-to-top]')) { window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' }); return; }
    const change = t.closest('[data-line-change]');
    if (change) {
      change.disabled = true;
      api(`${R.cartChange}.js`, { id: change.dataset.lineChange, quantity: Number(change.dataset.qtyTo) })
        .then(() => refreshCart())
        .catch(e => { toast(errorText(e)); refreshCart().catch(() => { change.disabled = false; }); });
    }
  });

  document.addEventListener('keydown', e => {
    // Tab bleibt im geöffneten Warenkorb bzw. mobilen Menü
    if (e.key === 'Tab' && (overlay === 'cart' || overlay === 'mmenu')) {
      const box = overlay === 'cart' ? drawer : mmenu;
      const items = $$('a[href], button:not([disabled]), input:not([type="hidden"]), summary, [tabindex]:not([tabindex="-1"])', box).filter(el => el.offsetParent !== null);
      if (items.length) {
        const first = items[0], last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || !box.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !box.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      }
    }
    if (e.key === 'Escape' && added && !added.hidden) { hideAdded(); return; }
    if (e.key === 'Escape' && overlay) { closeOverlay(); return; }
    const typing = /input|textarea|select/i.test(document.activeElement?.tagName || '') || document.activeElement?.isContentEditable;
    if (e.key === '/' && !typing && !overlay) { e.preventDefault(); openOverlay('search'); }
  });

  /* ---------- Start ---------- */
  const cartReady = refreshCart().catch(() => {});
  initHero();
  initCollection();
  initProduct();
  initRecommendations();
  initArticle();
  initToc();
  // Bilder und Schriften verändern die Seitenlänge: Scroll-Positionen danach neu vermessen
  window.addEventListener('load', () => ScrollTrigger.refresh());

  /* ---------- Produktleiste: Pfeil-Buttons statt Scrollbalken ---------- */
  document.querySelectorAll('[data-rail]').forEach(rail => {
    const nav = rail.closest('section')?.querySelector('[data-rail-nav]');
    if (!nav) return;
    const prev = nav.querySelector('[data-rail-prev]');
    const next = nav.querySelector('[data-rail-next]');
    const step = () => {
      const card = rail.firstElementChild;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card ? (card.getBoundingClientRect().width + gap) * 2 : rail.clientWidth * .8;
    };
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      nav.hidden = max < 4;
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft > max - 4;
    };
    prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
